import { supabase } from '../lib/supabase';

export const academicCalendarService = {
    // ACADEMIC YEARS
    getAcademicYears: async () => {
        // Trigger status update check whenever we fetch
        const { error: refreshError } = await supabase.rpc('update_academic_calendar_status');
        if (refreshError) console.warn('Academic status refresh was skipped:', refreshError.message);

        const { data, error } = await supabase
            .from('academic_years')
            .select('*')
            .order('start_date', { ascending: false });

        if (error) throw error;
        return data;
    },

    createAcademicYear: async (yearData) => {
        const { data, error } = await supabase
            .from('academic_years')
            .insert([yearData])
            .select()
            .single();

        if (error) throw error;
        return data;
    },

    updateAcademicYear: async (id, yearData) => {
        const { data, error } = await supabase
            .from('academic_years')
            .update(yearData)
            .eq('id', id)
            .select()
            .single();

        if (error) throw error;
        return data;
    },

    deleteAcademicYear: async (id) => {
        const { error } = await supabase
            .from('academic_years')
            .delete()
            .eq('id', id);

        if (error) throw error;
    },

    archiveAcademicYear: async (id, reason) => {
        const { data, error } = await supabase.rpc('archive_academic_year', {
            target_year: id,
            reason
        });
        if (error) throw error;
        return data;
    },

    getArchiveSummaries: async () => {
        const { data, error } = await supabase.rpc('get_academic_archive_summary');
        if (error) throw error;
        return data || [];
    },

    // SEMESTERS
    getSemesters: async (yearId) => {
        const { data, error } = await supabase
            .from('semesters')
            .select('*')
            .eq('academic_year_id', yearId)
            .order('term_number', { ascending: true });

        if (error) throw error;
        return data;
    },

    createSemester: async (semesterData) => {
        const { data, error } = await supabase
            .from('semesters')
            .insert([semesterData])
            .select()
            .single();

        if (error) throw error;
        return data;
    },

    updateSemester: async (id, semesterData) => {
        const { data, error } = await supabase
            .from('semesters')
            .update(semesterData)
            .eq('id', id)
            .select()
            .single();

        if (error) throw error;
        return data;
    },

    deleteSemester: async (id) => {
        const { error } = await supabase
            .from('semesters')
            .delete()
            .eq('id', id);

        if (error) throw error;
    },

    // Triggers the auto-update logic manually
    refreshStatus: async () => {
        const { error } = await supabase.rpc('update_academic_calendar_status');
        if (error) console.error("Auto-update status failed", error);
    },

    // CALENDAR EVENTS
    getCalendarEvents: async () => {
        const { data, error } = await supabase
            .from('calendar_events')
            .select('*')
            .order('start_date', { ascending: true });

        if (error) throw error;
        return data;
    },

    createCalendarEvent: async (eventData) => {
        const { data, error } = await supabase
            .from('calendar_events')
            .insert([eventData])
            .select()
            .single();

        if (error) throw error;
        return data;
    },

    updateCalendarEvent: async (id, eventData) => {
        const { data, error } = await supabase
            .from('calendar_events')
            .update(eventData)
            .eq('id', id)
            .select()
            .single();

        if (error) throw error;
        return data;
    },

    deleteCalendarEvent: async (id) => {
        const { error } = await supabase
            .from('calendar_events')
            .delete()
            .eq('id', id);

        if (error) throw error;
    }
};
